import React from 'react'
import { useTranslation } from 'react-i18next'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../ui/SafeIcon'

const testimonials = [
  { name: 'Michael Schmidt', role: 'Dropshipper', content: 'Seit ich 1688 Deutschland nutze, haben sich meine Margen verdoppelt. Die Zollabwicklung ist ein Traum.', rating: 5 },
  { name: 'Sarah Weber', role: 'Shop Owner', content: 'Der direkte Zugang zu Fabrikpreisen ohne Sprachbarriere ist genau das, was wir gebraucht haben.', rating: 5 },
  { name: 'Thomas Müller', role: 'Wholesaler', content: 'Hervorragender Service und schnelle Lieferung. Die Qualität der Produkte ist top.', rating: 4 }
]

function TestimonialsSection() {
  const { t } = useTranslation()

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          {t('testimonials.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((tr, i) => (
            <div key={i} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, idx) => (
                  <SafeIcon key={idx} icon={FiIcons.FiStar} className={`w-4 h-4 ${idx < tr.rating ? 'fill-current' : 'text-gray-300'}`} />
                ))}
              </div>
              <p className="text-gray-600 mb-6 italic">"{tr.content}"</p>
              <div>
                <div className="font-bold text-gray-900">{tr.name}</div>
                <div className="text-sm text-gray-500">{tr.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection